module.exports = __webpack_public_path__ + "img/icon_check.558f231a.png";